import { ACTION_FETCH_CLIENT_LIST_PENDING, ACTION_FETCH_CLIENT_LIST_SUCCESS, ACTION_FETCH_CLIENT_LIST_ERROR } from 'actions/client/action.client-list';

const initialState = {
    clientListFilter: {
        page: 1,
        pageSize: 20,
    },
    clientListPending: false,
    clientList: [],
    clientListError: null
}

export default function clientListReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION_FETCH_CLIENT_LIST_PENDING:
            return {
                ...state,
                clientListFilter: action.clientListFilter,
                clientListPending: true
            }
        case ACTION_FETCH_CLIENT_LIST_SUCCESS:
            return {
                ...state,
                clientListPending: false,
                clientList: action.clientList
            }
        case ACTION_FETCH_CLIENT_LIST_ERROR:
            return {
                ...state,
                clientListPending: false,
                clientListError: action.clientListError
            }
        default:
            return state;
    }
}

export const getClientListFilter = state => state.clientListReducer.clientListFilter;
export const getClientListPending = state => state.clientListReducer.clientListPending;
export const getClientList = state => state.clientListReducer.clientList;
export const getClientListError = state => state.clientListReducer.clientListError;
